/**
 * The record entities of the API. Paths, icons and what lists and cards show by
 * default; fields themselves come from Core's meta, never from here.
 */
export const ENTITIES = {
  account: { path: 'accounts', icon: 'fa-building', route: 'accounts', color: 'text-sky-600' },
  contact: { path: 'contacts', icon: 'fa-user', route: 'contacts', color: 'text-emerald-600' },
  lead: { path: 'leads', icon: 'fa-bullseye', route: 'leads', color: 'text-amber-600' },
  opportunity: { path: 'opportunities', icon: 'fa-sack-dollar', route: 'opportunities', color: 'text-violet-600' },
  activity: { path: 'activities', icon: 'fa-list-check', route: 'activities', color: 'text-rose-600' },
  note: { path: 'notes', icon: 'fa-note-sticky', route: 'notes', color: 'text-yellow-600' },
  offer: { path: 'offers', icon: 'fa-file-signature', route: 'offers', color: 'text-teal-600' },
  competitor: { path: 'competitors', icon: 'fa-chess-knight', route: 'competitors', color: 'text-slate-600' },
  campaign: { path: 'campaigns', icon: 'fa-bullhorn', route: 'campaigns', color: 'text-fuchsia-600' },
  marketing_list: { path: 'marketing-lists', icon: 'fa-address-book', route: 'marketing-lists', color: 'text-cyan-600' },
  event: { path: 'events', icon: 'fa-calendar-days', route: 'events', color: 'text-orange-600' },
  contract: { path: 'contracts', icon: 'fa-file-contract', route: 'contracts', color: 'text-green-700' },
  agreement: { path: 'agreements', icon: 'fa-handshake', route: 'agreements', color: 'text-emerald-700' },
  sales_material: { path: 'sales-materials', icon: 'fa-photo-film', route: 'sales-materials', color: 'text-pink-600' },
}

export const ENTITY_NAMES = Object.keys(ENTITIES)

export function entityPath(entity) {
  const def = ENTITIES[entity]
  if (!def) throw new Error(`Unknown entity ${entity}`)
  return def.path
}

export function entityByPath(path) {
  return Object.entries(ENTITIES).find(([, d]) => d.path === path)?.[0] || null
}

/** Columns a list shows when no view says otherwise. */
export const DEFAULT_COLUMNS = {
  account: ['name', 'type', 'industry', 'address', 'owner', 'last_activity_at'],
  contact: ['last_name', 'first_name', 'account', 'job_title', 'contact_points', 'owner'],
  lead: ['topic', 'company_name', 'rating', 'status', 'source', 'stage', 'owner', 'created_at'],
  opportunity: ['name', 'account', 'stage', 'estimated_value', 'probability', 'estimated_close_date', 'owner'],
  activity: ['type', 'subject', 'regarding', 'status', 'priority', 'scheduled_at', 'owner'],
  note: ['label', 'noteable', 'owner', 'updated_at'],
  offer: ['number', 'title', 'account', 'status', 'current_revision_no', 'document_date', 'created_at', 'valid_until', 'owner'],
  competitor: ['name', 'website', 'reported_revenue', 'is_active', 'owner'],
  campaign: ['number', 'name', 'type', 'status', 'proposed_start', 'budget', 'owner'],
  marketing_list: ['name', 'member_type', 'list_type', 'owner', 'updated_at'],
  event: ['number', 'name', 'type', 'status', 'start_at', 'location', 'owner'],
  contract: ['number', 'title', 'account', 'stage', 'execution_value', 'monthly_active', 'monthly_fee', 'signed_on', 'owner'],
  agreement: ['number', 'title', 'contract', 'account', 'kind', 'status', 'value', 'monthly_active', 'signed_on', 'owner'],
  sales_material: ['name', 'category', 'review_date', 'is_internal', 'is_active', 'owner'],
}

export const DEFAULT_SORT = {
  account: 'name',
  contact: 'last_name',
  lead: '-created_at',
  opportunity: 'estimated_close_date',
  activity: 'due_at',
  note: '-updated_at',
  offer: '-updated_at',
  competitor: 'name',
  campaign: '-proposed_start',
  marketing_list: 'name',
  event: '-start_at',
  contract: '-signed_on',
  agreement: '-signed_on',
  sales_material: 'name',
}

/** Layouts a list can switch to (D-50). */
export const LAYOUTS = {
  account: ['list', 'map'],
  contact: ['list'],
  lead: ['list', 'kanban'],
  opportunity: ['list', 'kanban', 'calendar'],
  activity: ['list', 'calendar'],
  note: ['list'],
  offer: ['list'],
  competitor: ['list'],
  campaign: ['list'],
  marketing_list: ['list'],
  event: ['list'],
  contract: ['list'],
  agreement: ['list'],
  sales_material: ['list'],
}
